/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseSmartFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/BaseSmartFormElement";
import dayjs from "dayjs";

export default class FormElementDateOfBirth extends BaseSmartFormElement {

	_disableFutureDates: boolean = true

	constructor(title, options = {}) {
		super(FormElementType.DATE_OF_BIRTH, title, {required: true, ...options});
	}

	getAnswerFormatted(){
		return dayjs(this.answer).format("MMM DD, YYYY")
	}


	resetElement() {
		super.resetElement();
		this._answerPlaceholderAnswerMode = "Click to select date"
		this.title = "Date of Birth"
		this.isRequired = true
		this.showRequiredSwitch = false
		this.placeholder = "Date of Birth Question Text"
		// this.disableEditing = true
		// this.specialQuestionDescription = "date of birth"
	}

	getSpecialQuestionDescription(){
		return "date of birth"
	}

	getSmartFiledPropertyName(){
		return "dateOfBirth"
	}

}
